import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import EventForm from './EventForm'

export default function EventEdit() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [initialData, setInitialData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const apiBase = import.meta.env.VITE_BACKEND_URL || ''
  const backend = apiBase.replace(/\/+$/, '')
  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const token = localStorage.getItem('token')
        const res = await fetch(`${backend}/events/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        const data = await res.json()
        if (!res.ok) throw new Error(data.error || 'Failed to load event')
        // Map server fields to formData structure
        setInitialData({
          firstName: data.submitterFirstName || '',
          lastName: data.submitterLastName || '',
          phoneNumber: data.submitterPhone || '',
          emailAddress: data.submitterEmail || '',
          groupName: data.groupName || '',
          eventDetails: data.eventDetails || '',
          businessesInvolved: data.businessesInvolved || '',
          eventDateRanges: data.eventDateRanges || [],
          startDate: data.startDate || '',
          endDate: data.endDate || '',
          promotionStartDate: data.promotionStartDate || '',
          promotionEndDate: data.promotionEndDate || '',
          commercial: data.isCommercial ? 'yes' : 'no',
          contentRating: data.contentRating || '',
          bar: data.isBarRelated ? 'yes' : 'no',
          dispensary: data.isDispensaryRelated ? 'yes' : 'no',
          additionalTags: data.additionalTags || [],
          title: data.title || '',
          description: data.description || '',
          location: data.location || '',
          website: data.website || '',
        })
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }
    fetchEvent()
  }, [backend, id])

  const handleUpdate = async (formData) => {
    try {
      const token = localStorage.getItem('token')
      const res = await fetch(`${backend}/events/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      })
      if (!res.ok) {
        const data = await res.json()
        throw new Error(data.error || 'Update failed')
      }
      alert('Event updated successfully')
      navigate('/user-dashboard')
    } catch (err) {
      alert('Error: ' + err.message)
    }
  }

  if (loading) return <p className="p-4">Loading event...</p>
  if (error) return <p className="p-4 text-error">Error: {error}</p>

  return (
    <section className="p-6 max-w-lg mx-auto space-y-6">
      <h2 className="text-2xl font-semibold">Edit Event</h2>
      <EventForm
        initialData={initialData}
        onSubmit={handleUpdate}
        skipCaptcha={true}
      />
      <button
        onClick={() => navigate(`/event-builder/${id}`)}
        className="mt-4 bg-primary text-white px-4 py-2 rounded hover:bg-primary-hover"
      >
        Open in Event Builder
      </button>
    </section>
  )
}